import React, { useState } from 'react';
import Button from '../../@base/Button';
import Accordion, { AccordionItem } from '../../@base/Accordion';
import TextArea from '../../@base/TextArea';
import AnswersOptionListComponent from './AnswersOptionListComponent';
import ContextMenu from '../../ContextMenu/ContextMenu';
import Input from '../../@base/Input';

const contentTypeDict = {
  TEXT: 'Texto',
  OPTIONS: 'Lista de Opções',
  IMAGE: 'Imagem',
};
/** Componente de detalhamento pergunta e resposta */
const AnswersComponent = (props) => {
  const [contents, setContents] = useState(props.answers[0].contents);

  const handleChangeContentTypeText = (idx, e) => {
    const { value } = e.target;
    if (contents[idx].text !== value) {
      const updatedContents = [...contents];
      updatedContents[idx].text = value;

      const updatedAnswers = [...props.answers];
      updatedAnswers[0].contents = updatedContents;
      props.handleChangeAnswer(updatedAnswers);
    }
  };

  const handleChangeContentTypeImage = (idx, e) => {
    const { value } = e.target;
    if (contents[idx].url !== value) {
      const updatedContents = [...contents];
      updatedContents[idx].url = value;

      const updatedAnswers = [...props.answers];
      updatedAnswers[0].contents = updatedContents;
      props.handleChangeAnswer(updatedAnswers);
    }
  };

  const handleChangeContentTypeOption = (idx, value) => {
    const updatedContents = [...contents];
    updatedContents[idx] = {
      ...value,
      options: value.options === undefined ? undefined
        : value.options.filter((option) => option.label !== '' || option.value !== ''),
    };

    const updatedAnswers = [...props.answers];
    updatedAnswers[0].contents = updatedContents;
    setContents([...updatedContents]);
    props.handleChangeAnswer(updatedAnswers);
  };

  const handleMoreAnswer = (type) => {
    let newContent = null;
    if (type === contentTypeDict.TEXT) {
      newContent = {
        type: 'TEXT',
        text: '',
      };
    } else if (type === contentTypeDict.OPTIONS) {
      newContent = {
        type: 'OPTIONS',
        display: 'button',
        title: '',
      };
    } else {
      newContent = {
        type: 'IMAGE',
        url: '',
      };
    }
    contents.push(newContent);
    setContents([...contents]);
  };

  const handleRemoveContent = (idx) => {
    const updatedContents = [...contents];
    updatedContents.splice(idx, 1);
    setContents([...updatedContents]);

    const updatedAnswers = [...props.answers];
    updatedAnswers[0].contents = updatedContents;
    props.handleChangeAnswer(updatedAnswers);
  };

  return (
    <>
      <Accordion>
        {contents.map((content, idx) => (
          <AccordionItem
            actionButtons={(
              <Button
                small
                circle
                classes="delete-response-type"
                title="Apagar resposta"
                onClick={() => handleRemoveContent(idx)}
                disabled={contents.length === 1}
              >
                <i className="fa fa-times" aria-hidden="true" />
              </Button>
          )}
          >
            <div>{contentTypeDict[content.type]}</div>
            <div>
              {content.type === 'TEXT'
                ? (
                  <TextArea
                    placeholder="Escreva o texto da resposta"
                    value={content.text}
                    onChange={(e) => handleChangeContentTypeText(idx, e)}
                  />
                ) : null }
              { content.type === 'OPTIONS' ? (
                <AnswersOptionListComponent
                  {...content}
                  update={(e) => handleChangeContentTypeOption(idx, e)}
                />
              ) : null}
              { content.type === 'IMAGE' ? (
                <>
                  <Input
                    label="Endereço da imagem:"
                    labelWidth="140px"
                    inline
                    placeholder="Endereço da imagem"
                    value={content.url}
                    onChange={(e) => handleChangeContentTypeImage(idx, e)}
                    classes="mb-2"
                  />
                  <div style={{ overflow: 'hidden', textAlign: 'center' }}>
                    <img
                      style={{ maxHeight: '120px' }}
                      src={content.url}
                    />
                  </div>
                  <div />
                </>
              ) : null}
            </div>
          </AccordionItem>

        ))}

      </Accordion>

      <div style={{ textAlign: 'center' }}>
        <div style={{ display: 'inline-block' }} className="mt-3 ">
          <ContextMenu
            button={(
              <Button
                small
                circle
                primary
                classes="more-item"
              >
                <i className="fa fa-plus" aria-hidden="true" />
              </Button>
              )}
            options={[contentTypeDict.TEXT, contentTypeDict.OPTIONS, contentTypeDict.IMAGE]
              .map((i) => (
                <a
                  role="button"
                  tabIndex={0}
                  onKeyPress={() => handleMoreAnswer(i)}
                  onClick={() => handleMoreAnswer(i)}
                >
                  {i}
                </a>
              ))}
          />
        </div>
        <div className="mt-3" />
      </div>

    </>
  );
};

export default AnswersComponent;
